import React from 'react';
import { Redirect, Route, Switch } from '@react-router';
import loadable from '@loadable/component';

import { useHotelRoutePaths } from './HotelBooking.routes';
import { TelemetryProvider as HotelBookingTelemetryProvider } from './HotelBooking.telemetry';

const HotelBooking = loadable(
  () =>
    import(
      /* webpackChunkName: "content/guest/hotelbooking/routes/hotelbooking" */
      '@apps/guest/routes/HotelBooking/routes/HotelBooking'
    ),
);

const RoomBlockHotel = loadable(
  () =>
    import(
      /* webpackChunkName: "content/guest/hotelbooking/routes/roomblockhotel" */
      '@apps/guest/routes/HotelBooking/routes/RoomBlockHotel'
    ),
);

export const HotelBookingApp: React.FC<{ eventHandle: string }> = ({ eventHandle }) => {
  const hotelRoutePaths = useHotelRoutePaths();
  return (
    <HotelBookingTelemetryProvider context={{ eventName: eventHandle }}>
      <Switch>
        <Route
          path={hotelRoutePaths.partnerhotels.path}
          render={({ match }) => {
            // Don't seen traffic in amplitude for guest.travel.hotelbookingpartner, cleaned old code. Kept redirect to hoteldetails route if in case any.
            return <Redirect to={`/${eventHandle}/hotel/${match.params.hotelId}`} />;
          }}
        />
        <Route
          path={hotelRoutePaths.roomblock.path}
          render={({ match }) => {
            return <RoomBlockHotel roomBlockHotelId={match.params.id || null} />;
          }}
        />
        <Route
          path={hotelRoutePaths.hotelbooking.path}
          render={() => <HotelBooking eventHandle={eventHandle} />}
        />
      </Switch>
    </HotelBookingTelemetryProvider>
  );
};
